import menuArrowIcon from "@assets/images/menu-arrow-icon.svg";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import React, { FC } from "react";
import Svg from "react-inlinesvg";

import { IUnlockCode, IUnlockCodeErrorDetail } from "../../useUnlockCodesState";
import {
  generateCardBorderColor,
  generateCollapsedCardErrorText,
  hasError
} from "../../utils";
import useStyles from "./styles";

interface ICollapsedCardProps {
  unlockCodeData: IUnlockCode;
  unlockCodeErrors: IUnlockCodeErrorDetail;
  onExpand: () => void;
}

const CollapsedCard: FC<ICollapsedCardProps> = ({
  unlockCodeData,
  unlockCodeErrors,
  onExpand
}) => {
  const classes = useStyles({
    cardBorderLeftColor: generateCardBorderColor(
      unlockCodeData,
      unlockCodeErrors
    )
  });

  const displayErrorText = generateCollapsedCardErrorText(unlockCodeErrors);

  return (
    <div className={classes.collapsedCardContainer}>
      {hasError(unlockCodeErrors) ? (
        <div className={classes.collapsedCardErrorContainer}>
          <InfoOutlined
            fontSize="small"
            style={{
              position: "relative",
              top: 1
            }}
          />
          {displayErrorText}
        </div>
      ) : (
        <div>{unlockCodeData.unlockCode}</div>
      )}
      <div
        id={`unlockCode${unlockCodeData.componentKey}-collapsedArrowIcon`}
        onClick={onExpand}
        className={classes.expandArrowContainer}
      >
        <Svg src={menuArrowIcon} />
      </div>
    </div>
  );
};

export default CollapsedCard;
